import { apiCall } from "./service";
import { BASE_URL } from "./URL";

export const timesheetApi = {
  // USER ENDPOINTS
  getMyWeek(params) {
    const { year, week } = params;
    return apiCall.get({
      url: `${BASE_URL}timesheets/my?year=${year}&week=${week}`,
      isAuthToken: true,
    });
  },

  saveMyTimesheet(payload) {
    return apiCall.post({
      url: `${BASE_URL}timesheets/my`,
      isAuthToken: true,
      params: payload,
    });
  },

  submitMyTimesheet(entryId) {
    return apiCall.post({
      url: `${BASE_URL}timesheets/my/${entryId}/submit`,
      isAuthToken: true,
    });
  },

  // PM ENDPOINTS
  getPendingValidations(filters) {
    const { year, week, status } = filters;
    const queryParams = new URLSearchParams();
    if (year) queryParams.append('year', year);
    if (week) queryParams.append('week', week);
    if (status !== undefined) queryParams.append('status', status);

    return apiCall.get({
      url: `${BASE_URL}timesheets/team?${queryParams.toString()}`,
      isAuthToken: true,
    });
  },

  getUserWeekForValidation(params) {
    const { userId, projectId, year, week } = params;
    return apiCall.get({
      url: `${BASE_URL}timesheets/team/${userId}/project/${projectId}?year=${year}&week=${week}`,
      isAuthToken: true,
    });
  },

  saveUserTimesheet(payload) {
    return apiCall.post({
      url: `${BASE_URL}timesheets/manage`,
      isAuthToken: true,
      params: payload,
    });
  },

  submitUserTimesheet(entryId) {
    return apiCall.post({
      url: `${BASE_URL}timesheets/${entryId}/submit`,
      isAuthToken: true,
    });
  },

  updateTimesheetCashflowLine(entryId, cashflowLineId, data) {
    return apiCall.put({
      url: `${BASE_URL}timesheets/${entryId}/cashflowLine/${cashflowLineId}`,
      params: data,
      isAuthToken: true,
    });
  },

  validateTimesheet(entryId) {
    return apiCall.post({
      url: `${BASE_URL}timesheets/${entryId}/validate`,
      isAuthToken: true,
    });
  },

  invalidateTimesheet(entryId) {
    return apiCall.post({
      url: `${BASE_URL}timesheets/${entryId}/invalidate`,
      isAuthToken: true,
    });
  },

  getProjectWeekSummary(params) {
    const { projectId, year, week } = params;
    return apiCall.get({
      url: `${BASE_URL}timesheets/project/${projectId}/week?year=${year}&week=${week}`,
      isAuthToken: true,
    });
  },
};

export default timesheetApi;
